export const categories = [
  { id: 'dianying', name: '电影', slug: 'dianying', icon: 'ri-movie-2-line', description: '最新电影高清在线观看，动作片、喜剧片、爱情片、科幻片等各类电影免费全集' },
  { id: 'dianshiju', name: '电视剧', slug: 'dianshiju', icon: 'ri-tv-2-line', description: '热门电视剧全集免费在线播放，国产剧、港台剧、韩剧、美剧一网打尽' },
  { id: 'zongyi', name: '综艺', slug: 'zongyi', icon: 'ri-live-line', description: '最新综艺节目在线观看，真人秀、脱口秀、音乐节目精彩不停' },
  { id: 'dongman', name: '动漫', slug: 'dongman', icon: 'ri-rocket-line', description: '热门动漫免费全集在线观看，日漫、国漫、剧场版高清不缓冲' },
  { id: 'jilupian', name: '纪录片', slug: 'jilupian', icon: 'ri-camera-line', description: '精选纪录片高清在线观看，自然、历史、科技、人文精彩纪录片' },
];

export const heroSlides = [
  {
    id: 1,
    title: '流浪地球3：星辰大海',
    subtitle: '2026年最受期待的科幻巨制，震撼回归',
    category: '电影',
    rating: 9.2,
    image: 'https://readdy.ai/api/search-image?query=A%20cinematic%20sci-fi%20scene%20with%20a%20massive%20spaceship%20traveling%20through%20a%20colorful%20nebula%2C%20stars%20in%20the%20background%2C%20dramatic%20lighting%2C%20warm%20orange%20and%20deep%20space%20blue%20gradient%2C%20epic%20composition%2C%20movie%20poster%20style%20with%20soft%20glow%20effects&width=1600&height=700&seq=hero-slide-01&orientation=landscape',
  },
  {
    id: 2,
    title: '长安十二时辰第二季',
    subtitle: '古装悬疑巨制，盛世之下的暗流涌动',
    category: '电视剧',
    rating: 9.5,
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20city%20night%20scene%20with%20lanterns%20and%20traditional%20architecture%2C%20mysterious%20atmosphere%2C%20warm%20golden%20lighting%2C%20Tang%20Dynasty%20style%20buildings%2C%20cinematic%20movie%20poster%20aesthetic%20with%20dramatic%20shadows&width=1600&height=700&seq=hero-slide-02&orientation=landscape',
  },
  {
    id: 3,
    title: '乘风破浪的姐姐第六季',
    subtitle: '全新阵容，舞台炸裂回归',
    category: '综艺',
    rating: 8.8,
    image: 'https://readdy.ai/api/search-image?query=A%20dazzling%20concert%20stage%20with%20colorful%20spotlights%20and%20sparkle%20effects%2C%20glamorous%20performance%20atmosphere%2C%20warm%20and%20vibrant%20lighting%2C%20entertainment%20show%20poster%20style%2C%20dynamic%20composition%20with%20stage%20fog%20and%20golden%20accents&width=1600&height=700&seq=hero-slide-03&orientation=landscape',
  },
];

export const featuredVideos = [
  {
    id: 1,
    title: '深海迷航',
    category: '电影',
    categorySlug: 'dianying',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20mysterious%20deep%20ocean%20scene%20with%20bioluminescent%20creatures%2C%20submarine%20exploring%20underwater%20ruins%2C%20ethereal%20blue-green%20lighting%2C%20cinematic%20movie%20poster%20style%20with%20soft%20ambient%20glow%20and%20bubble%20effects&width=600&height=400&seq=featured-01&orientation=landscape',
    rating: 9.1,
    views: '128.5万',
    duration: '02:18:45',
    quality: '4K',
    description: '深海探险队意外发现神秘水下文明，一场惊心动魄的冒险之旅就此展开。',
    date: '2026-07-28',
  },
  {
    id: 2,
    title: '繁花似锦',
    category: '电视剧',
    categorySlug: 'dianshiju',
    thumbnail: 'https://readdy.ai/api/search-image?query=Elegant%20Chinese%20period%20drama%20scene%20with%20a%20woman%20in%20traditional%20qipao%20dress%20in%20an%20art%20deco%20Shanghai%20setting%2C%20warm%20golden%20lighting%2C%20nostalgic%20atmosphere%2C%20cinematic%20composition%20with%20soft%20blur%20background&width=600&height=400&seq=featured-02&orientation=landscape',
    rating: 9.3,
    views: '256.8万',
    duration: '45集',
    quality: '1080P',
    description: '民国上海滩的爱情与商战传奇，三个女人的命运交织成一幅繁华画卷。',
    date: '2026-07-25',
  },
  {
    id: 3,
    title: '极限挑战第十季',
    category: '综艺',
    categorySlug: 'zongyi',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20fun%20outdoor%20adventure%20reality%20show%20scene%20with%20people%20running%20in%20a%20colorful%20obstacle%20course%2C%20bright%20sunny%20day%2C%20energetic%20atmosphere%2C%20vibrant%20and%20playful%20poster%20style%20with%20confetti%20effects&width=600&height=400&seq=featured-03&orientation=landscape',
    rating: 8.7,
    views: '189.3万',
    duration: '2026-07-30',
    quality: '1080P',
    description: '极限男人帮再度集结，全新挑战全新体验，笑料不断精彩不停。',
    date: '2026-07-30',
  },
  {
    id: 4,
    title: '仙王的日常生活第三季',
    category: '动漫',
    categorySlug: 'dongman',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20colorful%20anime%20style%20scene%20with%20a%20young%20cultivator%20in%20traditional%20Chinese%20robe%20using%20magic%20powers%2C%20floating%20islands%20and%20clouds%2C%20vibrant%20and%20warm%20color%20palette%2C%20fantasy%20animation%20poster%20style%20with%20sparkle%20effects&width=600&height=400&seq=featured-04&orientation=landscape',
    rating: 9.0,
    views: '312.6万',
    duration: '12集',
    quality: '1080P',
    description: '修真界最强仙王隐姓埋名进入现代高中，笑料与热血交织的校园生活。',
    date: '2026-07-20',
  },
  {
    id: 5,
    title: '地球脉动第三季',
    category: '纪录片',
    categorySlug: 'jilupian',
    thumbnail: 'https://readdy.ai/api/search-image?query=Stunning%20nature%20documentary%20scene%20showing%20a%20snow%20leopard%20on%20a%20mountain%20ridge%20at%20sunset%2C%20dramatic%20golden%20hour%20lighting%2C%20breathtaking%20landscape%2C%20epic%20cinematic%20composition%20with%20warm%20natural%20tones&width=600&height=400&seq=featured-05&orientation=landscape',
    rating: 9.8,
    views: '456.2万',
    duration: '8集',
    quality: '4K HDR',
    description: 'BBC经典纪录片系列最新力作，用4K HDR镜头探索地球上最壮丽的自然奇观。',
    date: '2026-07-15',
  },
  {
    id: 6,
    title: '狂飙2：暗流',
    category: '电视剧',
    categorySlug: 'dianshiju',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20tense%20crime%20drama%20scene%20in%20a%20modern%20Chinese%20city%20at%20night%2C%20police%20car%20with%20flashing%20lights%2C%20rainy%20street%2C%20noir%20atmosphere%2C%20cinematic%20thriller%20poster%20style%20with%20dramatic%20contrast%20lighting&width=600&height=400&seq=featured-06&orientation=landscape',
    rating: 9.4,
    views: '523.7万',
    duration: '40集',
    quality: '4K',
    description: '扫黑除恶行动持续深入，新的黑暗势力浮出水面，正义与邪恶的终极较量。',
    date: '2026-07-10',
  },
];

export const hotRankings = [
  { rank: 1, title: '流浪地球3：星辰大海', category: '电影', hot: '986.5万', trend: 'up' },
  { rank: 2, title: '狂飙2：暗流', category: '电视剧', hot: '923.1万', trend: 'up' },
  { rank: 3, title: '长安十二时辰第二季', category: '电视剧', hot: '876.3万', trend: 'up' },
  { rank: 4, title: '仙王的日常生活第三季', category: '动漫', hot: '754.8万', trend: 'up' },
  { rank: 5, title: '繁花似锦', category: '电视剧', hot: '698.2万', trend: 'down' },
  { rank: 6, title: '深海迷航', category: '电影', hot: '632.6万', trend: 'up' },
  { rank: 7, title: '极限挑战第十季', category: '综艺', hot: '587.4万', trend: 'down' },
  { rank: 8, title: '地球脉动第三季', category: '纪录片', hot: '542.9万', trend: 'up' },
  { rank: 9, title: '乘风破浪的姐姐第六季', category: '综艺', hot: '498.7万', trend: 'up' },
  { rank: 10, title: '大秦帝国之天下', category: '电视剧', hot: '465.3万', trend: 'down' },
];

export const latestUpdates = [
  {
    id: 11,
    title: '大秦帝国之天下',
    category: '电视剧',
    categorySlug: 'dianshiju',
    thumbnail: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20historical%20drama%20with%20ancient%20Qin%20Dynasty%20soldiers%20in%20armor%20marching%20across%20a%20vast%20battlefield%2C%20dramatic%20sky%20with%20golden%20sunset%2C%20cinematic%20composition%20with%20warm%20earth%20tones&width=600&height=400&seq=latest-01&orientation=landscape',
    rating: 9.2,
    views: '365.2万',
    quality: '4K',
    updateInfo: '更新至48集',
    description: '战国末年，秦王嬴政一统天下的热血史诗巨制。',
  },
  {
    id: 12,
    title: '你好，李焕英2',
    category: '电影',
    categorySlug: 'dianying',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20heartwarming%20Chinese%20family%20comedy%20scene%20with%20mother%20and%20daughter%20laughing%20together%20in%20a%20cozy%20home%2C%20warm%20golden%20afternoon%20light%20through%20window%2C%20nostalgic%201980s%20Chinese%20setting%2C%20cinematic%20style&width=600&height=400&seq=latest-02&orientation=landscape',
    rating: 9.0,
    views: '198.6万',
    quality: '1080P',
    updateInfo: '2026-07-31',
    description: '续写母女之间的温情故事，笑中带泪的亲情喜剧。',
  },
  {
    id: 13,
    title: '斗罗大陆第二季',
    category: '动漫',
    categorySlug: 'dongman',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20fantasy%20anime%20scene%20with%20a%20young%20warrior%20holding%20a%20glowing%20hammer%20weapon%2C%20magical%20energy%20spiraling%20around%2C%20epic%20battle%20atmosphere%2C%20vibrant%20anime%20art%20style%20with%20dramatic%20lighting&width=600&height=400&seq=latest-03&orientation=landscape',
    rating: 9.1,
    views: '456.8万',
    quality: '1080P',
    updateInfo: '更新至126集',
    description: '唐三带领史莱克七怪踏上新的征程，魂师世界的冒险仍在继续。',
  },
  {
    id: 14,
    title: '王牌对王牌第九季',
    category: '综艺',
    categorySlug: 'zongyi',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20lively%20variety%20show%20studio%20with%20colorful%20stage%20lights%2C%20two%20teams%20of%20celebrities%20competing%20in%20a%20fun%20game%2C%20bright%20and%20energetic%20atmosphere%2C%20entertainment%20show%20poster%20style&width=600&height=400&seq=latest-04&orientation=landscape',
    rating: 8.6,
    views: '289.3万',
    quality: '1080P',
    updateInfo: '2026-07-29',
    description: '王牌家族再度集结，全新游戏环节爆笑升级。',
  },
  {
    id: 15,
    title: '航拍中国第五季',
    category: '纪录片',
    categorySlug: 'jilupian',
    thumbnail: 'https://readdy.ai/api/search-image?query=Stunning%20aerial%20view%20of%20Chinese%20landscape%20with%20terraced%20rice%20fields%20and%20misty%20mountains%20at%20sunrise%2C%20golden%20morning%20light%2C%20breathtaking%20natural%20scenery%2C%20documentary%20cinematography%20style&width=600&height=400&seq=latest-05&orientation=landscape',
    rating: 9.6,
    views: '178.5万',
    quality: '4K HDR',
    updateInfo: '更新至6集',
    description: '以空中视角俯瞰美丽中国，全新一季探访更多绝美秘境。',
  },
  {
    id: 16,
    title: '孤注一掷2：暗网',
    category: '电影',
    categorySlug: 'dianying',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20suspenseful%20crime%20thriller%20scene%20in%20a%20dimly%20lit%20room%20with%20computer%20screens%20showing%20code%2C%20mysterious%20silhouette%2C%20tense%20noir%20atmosphere%2C%20cinematic%20style%20with%20cool%20and%20warm%20contrast%20lighting&width=600&height=400&seq=latest-06&orientation=landscape',
    rating: 8.9,
    views: '342.1万',
    quality: '4K',
    updateInfo: '2026-07-27',
    description: '网络诈骗题材续作，深入暗网世界揭露更惊人的犯罪真相。',
  },
];

export const articles = [
  {
    id: 1,
    title: '深海迷航——国产科幻电影的新里程碑',
    category: '电影',
    categorySlug: 'dianying',
    author: '影视评论员小王',
    date: '2026-07-30',
    views: '86.5万',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20mysterious%20deep%20ocean%20exploration%20scene%20with%20a%20submarine%20approaching%20an%20ancient%20underwater%20city%2C%20bioluminescent%20creatures%2C%20ethereal%20blue%20lighting%2C%20cinematic%20wide%20shot%20with%20epic%20scale&width=800&height=500&seq=article-01&orientation=landscape',
    excerpt: '在国产科幻电影集体爆发的2026年，《深海迷航》以其独特的深海探险题材和震撼的视觉特效，为观众带来了一场前所未有的观影体验。',
    content: '<p>在国产科幻电影集体爆发的2026年，《深海迷航》以其独特的深海探险题材和震撼的视觉特效，为观众带来了一场前所未有的观影体验。导演陈思远带领团队耗时三年，深入研究了海洋生物学和深海地质学，将科学严谨性与天马行空的想象力完美结合。</p><p>影片讲述了一支由中国科学家组成的深海探险队，在探索马里亚纳海沟最深处时，意外发现了一个隐藏在万米深渊之下的史前文明遗迹。随着探索的深入，他们逐渐揭开了这个神秘文明的面纱，也面临着前所未有的危险与挑战。</p><p>从视觉效果来看，《深海迷航》无疑是国产电影中技术层面的一次重大突破。影片中呈现的深海环境、生物发光的奇异景象，以及水下文明遗迹的宏大场景，每一帧都堪称视觉盛宴。尤其值得一提的是，团队自主研发的深海流体模拟系统，让影片中的水下场景显得格外真实自然。</p><p>在叙事层面，导演巧妙地平衡了科幻奇观与人文关怀。探险队成员之间复杂的人际关系、面对未知时的恐惧与勇气，以及对于人类与自然关系的深刻思考，都让这部影片超越了单纯的视觉奇观，成为一部有深度的科幻佳作。</p>',
    tags: ['科幻', '国产电影', '深海', '视觉特效', '2026新片'],
  },
  {
    id: 2,
    title: '繁花似锦：民国剧的新高度，三个女人一台戏',
    category: '电视剧',
    categorySlug: 'dianshiju',
    author: '剧评人老张',
    date: '2026-07-28',
    views: '125.3万',
    thumbnail: 'https://readdy.ai/api/search-image?query=Elegant%201930s%20Shanghai%20street%20scene%20with%20three%20women%20in%20beautiful%20qipao%20dresses%20walking%20together%2C%20art%20deco%20buildings%20background%2C%20warm%20nostalgic%20golden%20lighting%2C%20cinematic%20period%20drama%20aesthetic&width=800&height=500&seq=article-02&orientation=landscape',
    excerpt: '豆瓣开分9.3，《繁花似锦》用精致的影像和细腻的情感，重新定义了民国题材电视剧的高度。',
    content: '<p>豆瓣开分9.3，《繁花似锦》用精致的影像和细腻的情感，重新定义了民国题材电视剧的高度。这部剧以1930年代的上海为背景，讲述了三位出身不同、性格迥异的女性在乱世中的命运沉浮。</p><p>导演林夕以其独特的女性视角，将镜头对准了那个特殊年代里女性的生存状态。沈若兰是名门闺秀，家道中落后不得不独自谋生；苏曼云是留洋归来的新女性，带着西洋的思想在上海滩闯荡；林小蝶出身贫寒，靠自己的努力一步步在商界立足。三个女人的故事交织在一起，构成了一幅绚丽的时代画卷。</p><p>在制作层面，《繁花似锦》展现出了极高的审美水准。从服装道具到场景布置，每一个细节都经得起推敲。摄影师出身的导演对画面构图的把控堪称完美，每一帧都像是一幅精心绘制的油画。配乐方面，融合了传统民乐和爵士乐的元素，营造出独特的时代氛围。</p><p>这部剧最打动人的，是它对女性命运的深刻关怀。在那个男权主导的时代，三个女主角用自己的方式诠释了何为独立、何为尊严、何为爱情。这不仅是一部民国剧，更是一部关于女性觉醒与成长的史诗。</p>',
    tags: ['民国剧', '女性题材', '上海滩', '高分剧集', '2026热播'],
  },
  {
    id: 3,
    title: '狂飙2：暗流——扫黑剧如何突破天花板',
    category: '电视剧',
    categorySlug: 'dianshiju',
    author: '影视深度观察',
    date: '2026-07-25',
    views: '198.7万',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20gritty%20crime%20drama%20scene%20in%20a%20modern%20Chinese%20city%2C%20two%20detectives%20discussing%20case%20files%20in%20a%20dimly%20lit%20office%2C%20evidence%20board%20with%20photos%20and%20connections%2C%20noir%20cinematic%20style%20with%20high%20contrast&width=800&height=500&seq=article-03&orientation=landscape',
    excerpt: '作为现象级扫黑剧的续作，《狂飙2：暗流》面临着巨大的压力和期待。它是如何突破前作的天花板的？',
    content: '<p>作为现象级扫黑剧的续作，《狂飙2：暗流》从开播之日起就面临着巨大的压力和期待。前作《狂飙》创造的收视奇迹和话题热度，让续作的每一个创作选择都备受关注。令人惊喜的是，续作不仅没有让人失望，反而在多方面实现了突破。</p><p>本季的故事设定在前作事件发生三年后，扫黑除恶行动取得了阶段性成果，但新的黑暗势力以更隐蔽的方式悄然滋生。主角安欣和指导组面临着更加复杂的局面——黑恶势力已经渗透到了经济的更深层次，手段也更加高科技化和隐蔽化。</p><p>在叙事结构上，第二季采用了更加复杂的时间线交错手法，将现在的调查过程与过去的案件线索交织在一起，营造出强烈的悬疑感和代入感。在人物塑造上，新加入的角色各具特色，反派角色的刻画也更加立体，不再是简单的善恶二元对立。</p><p>从社会意义来看，《狂飙2》不仅仅是一部娱乐性的电视剧，它深刻反映了当代社会治理中面临的真实挑战，引发了观众对于法治、正义、人性等深层次话题的思考。这也正是为什么它能超越单纯的类型剧范畴，成为一部具有社会价值的优秀作品。</p>',
    tags: ['扫黑剧', '犯罪题材', '现实题材', '高分剧集', '2026热播'],
  },
];

export const aboutInfo = {
  brandName: '小蓝视频',
  slogan: '高清不缓冲，免费看全集',
  founded: '2018年',
  headquarters: '中国北京',
  introduction: '小蓝视频成立于2018年，是国内领先的高清影视资源聚合平台。我们致力于为全球中文用户提供最优质的在线视频观看体验，聚合了包括91视频、芒果视频、91在线视频、菠萝视频、51视频在内的多家优质平台资源，让用户在一个平台上即可畅享海量高清影视内容。',
  mission: '我们的使命是让每一个中文用户都能方便快捷地观看到自己喜欢的高清视频内容，无需缓冲等待，无需付费门槛。我们相信，优质的影视内容应该被更多人看到。',
  values: [
    { title: '用户体验至上', description: '持续优化播放体验，确保高清流畅不缓冲' },
    { title: '内容丰富多元', description: '聚合多家平台资源，覆盖电影电视剧综艺动漫纪录片' },
    { title: '技术驱动创新', description: '运用最新流媒体技术，提供极速加载体验' },
    { title: '用户隐私保护', description: '严格遵守数据保护规范，保障用户信息安全' },
  ],
  achievements: [
    { number: '5000万+', label: '月活跃用户' },
    { number: '10万+', label: '影视资源' },
    { number: '99.9%', label: '播放成功率' },
    { number: '200+', label: '合作平台' },
  ],
  testimonials: [
    { name: '李明', role: '资深影迷', content: '小蓝视频是我用过的最好用的影视平台，资源全、更新快、画质好，强烈推荐给所有喜欢看电影的朋友。' },
    { name: '王芳', role: '追剧达人', content: '追剧必备！新剧更新速度超级快，画质清晰流畅，再也没有卡顿的烦恼了，真心好用。' },
    { name: '张伟', role: '动漫爱好者', content: '动漫资源非常全，无论是热门新番还是经典老番都能找到，而且都是高清资源，看得很过瘾。' },
    { name: '陈静', role: '综艺粉丝', content: '综艺节目更新最快！各大平台的热门综艺第一时间同步，再也不用到处找了，一个平台全搞定。' },
  ],
  contact: {
    email: 'contact@xiaolanvideo.com',
    phone: '400-888-0000',
    address: '北京市朝阳区建国路88号SOHO现代城A座',
    wechat: 'xiaolanshipin',
    weibo: '@小蓝视频官方',
  },
};

export const faqs = [
  {
    question: '小蓝视频需要付费吗？',
    answer: '小蓝视频完全免费使用，所有影视内容均可免费在线观看，无需付费订阅或购买会员。',
  },
  {
    question: '视频画质如何？能否支持高清播放？',
    answer: '我们提供1080P和4K超高清画质选项，采用先进的流媒体传输技术，确保高清不缓冲的流畅播放体验。',
  },
  {
    question: '支持哪些设备观看？',
    answer: '小蓝视频支持电脑、平板和手机等多种设备观看，适配主流浏览器，随时随地畅享高清影视。',
  },
  {
    question: '视频更新速度快吗？',
    answer: '我们与多家视频平台保持紧密合作，新剧和热门电影会在第一时间同步更新，让您不错过任何精彩内容。',
  },
  {
    question: '如何搜索想看的视频？',
    answer: '您可以使用网站顶部的搜索功能，输入影片名称或关键词即可快速找到相关视频资源。同时您也可以通过分类导航浏览不同类型的影片。',
  },
];